import type { PropsWithChildren } from 'react';

type BlogFeaturedTitleProps = PropsWithChildren;

export const BlogFeaturedTitle = ( { children }: BlogFeaturedTitleProps ) => {

  return (
    <div className={ 'font-onest text-base font-semibold leading-[22px] group-data-[variant="light"]:text-black flex items-center flex-row' }>
      { children }
    </div>
  )
}
BlogFeaturedTitle.displayName = 'BlogFeaturedTitle';
